/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CCDView } from 'cchome-apps';
import AppsUtils from './AppsUtils';
import Footer from '../../components/Footer/Footer';
import { getEnvironment } from '../../../utils/Environment';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import Navbar from '../../components/NavBar/Navbar';
import './CCD.scss';
import PostIMSFetchService from '../../services/PostIMSFetchService';

/* eslint-enable no-unused-vars */

type Props = {
	match: Object;
	history: Object;
	locale: string;
	profile: any;
};

class CCD extends Component<Props> {
	componentDidMount() {
		const analytics = new AnalyticsUtil(false, false);
		analytics.postMainCCHLOERender();
	}

	getContainerClass(pathObject: any) {
		let className = 'main-container fullscreen';
		if (pathObject.pageType === 'campaign') {
			className = `${className} campaign`;
		}
		return className;
	}

	render() {
		const serviceLevel =
			this.props.profile && this.props.profile.serviceAccounts && this.props.profile.serviceAccounts[0]
				? this.props.profile.serviceAccounts[0].serviceLevel
				: null;
		const pathObject = AppsUtils.getPathData();
		const env = getEnvironment();
		const lang = this.props.locale || 'en';
		const { profile } = this.props;
		const { profileTimeoutOrError, profileFetchFinished } = profile;
		let userId;
		if (window.adobeIMS.getUserProfile()) {
			userId = window.adobeIMS.getUserProfile()?.authId || window.adobeIMS.getUserProfile()?.userId;
		}
		if (
			window.adobeIMS &&
			window.adobeIMS.getAccessToken() &&
			window.adobeIMS.getUserProfile() &&
			// @ts-ignore
			userId &&
			!(profileFetchFinished || profileTimeoutOrError)
		) {
			return null;
		}
		if (document.documentElement) {
			document.documentElement.lang = lang;
		}

		/* set browser type */
		if (document.documentElement) {
			document.documentElement.setAttribute('data-browser', window.cchome.util.getBrowserType());
		}
		return (
			<CCDView
				environment={env}
				imsData={AppsUtils.getIMSData()}
				locale={lang}
				routeParams={pathObject}
				routing={true}
				serviceLevel={serviceLevel}
				preFetchedRestAPIResponses={PostIMSFetchService.getResponseForKey}
				profile={this.props.profile}
			/>
		);
	}
}

function mapStateToProps(state) {
	return {
		profile: state.profile,
	};
}

export default {
	component: connect(mapStateToProps)(CCD),
};
